import '../styles/bgs.css';
import Banner from "../components/Partners/banner";
import AboutPartnerStart from "../components/About/partnerStart";
import PartnerForm from "../components/Forms/Partner";

function About() {
  return (
    <>
      <div className='w-full bg-white overflow-hidden'>
        <div className='container mx-auto px-4 py-8 my-[120px] xl:mb-[65px] xl:mt-[90px]'>
          <Banner />
        </div>
      </div>
      <div className="w-full bg-white overflow-hidden">
        <div className='container mx-auto lg:px-4 mt-[120px] lg:mt-[118px]'>
          <AboutPartnerStart />
        </div>
      </div>
      <div className="w-full bg-white overflow-hidden">
        <div id="partner-form" className='container mx-auto px-4 w-full flex justify-center xl:pt-[0px] mb-[120px] xl:mb-[100px]'>
          <PartnerForm />
        </div>
      </div>
    </>
  );
}

export default About; 